import { render } from "./hostPath.vue?vue&type=template&id=20fc4dbc"
import script from "./hostPath.vue?vue&type=script&lang=js"
export * from "./hostPath.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__